import ApiService from './api.service';

const EventsService = token => {
    const api = ApiService.createApiInstance(token);

    return {
        get(id) {
            return api.get(`/Events/${id}`);
        },
        getAdmin(eventId) {
            return api.get(`/Events/admin-edit/${eventId}`);
        },
        updateAdmin(eventId, data) {
            return api.put(`/Events/admin-edit/${eventId}`, data);
        },
        createIsoRenderJob(eventId) {
            return api.post(`/render/create-iso/${eventId}`);
        },
        deleteIso(eventId) {
            return api.delete(`/Events/delete-iso/${eventId}`);
        },
    };
};

export default EventsService;
